import * as types from 'actions/actionTypes';
import initialState from './initialState';

/**
 * reducer per gestire le interrogazioni a crashboxx/services/icnplus/accelerationpairs
 * @param {*} state
 * @param {*} action
 */
export default function icnAccelerationReducer(state = initialState.icnAccelerationSearch, action){

    switch(action.type)
    {
        case types.GET_ICNACCELERATION_REQUEST:
            return {...state, list: [], item: null, error: null, isSearching: true};
        case types.GET_ICNACCELERATION_SUCCESS:
            return {...state, list: action.data.accelertaiondata.accelerationPairs, error: null, isSearching: false};
        case types.GET_ICNACCELERATION_ERROR:
            return {...state, list: [], error: action.data, isSearching: false};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/icnAccelerationReducer.js